/**
 * Privacy-conscious analytics. Only the whitelisted events below are tracked and
 * NEVER any question text, e-mail, name, state, token or moderation data.
 */
const ALLOWED = [
  "hero_cta_clicked",
  "form_started",
  "form_completed",
  "verification_completed",
  "methodology_viewed",
  "share_clicked",
  "podcast_watch_clicked",
];

export function track(event) {
  if (!ALLOWED.includes(event)) return;
  try {
    if (typeof window !== "undefined" && window.posthog?.capture) {
      window.posthog.capture(event);
    }
  } catch (e) {
    /* analytics must never break the UI */
  }
}
